import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/reach-registration-compliance-support")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/reach-registration-compliance-support", statusCode: 301 }); },
});
